<template>
    <div class="list-header">
        <div class="d-flex flex-column flex-md-row justify-content-sm-center justify-content-md-between">
            <div class="d-flex align-items-center" style="margin: 10px 0px">
                <BButton aria-controls="collapse-4" @click="rotation" class="caret-icon" style="margin-left: 10px;">
                    <img class="transition" v-bind:style="{transform: `rotate(${deg}deg)`}" src="~@/assets/pack_go/caret-right-icon.svg"/>
                </BButton >
                <div v-if="!is_empty" style="margin-left: 20px">
                    <div class="d-flex">
                        <span class="order-id-label">945-Y-23</span>
                        <span class="header-item-count">({{ item_count[item_index] }} items)</span>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex align-items-center" style="margin-right: 10px">
                            <img src="~@/assets/pack_go/dhl-icon.svg" style="width: 2rem"/>
                            <p class="list-label">DHL ForYou Drop Off</p>
                            <img src="~@/assets/pack_go/caret-down-icon.svg" style="margin-left: 5px; width: 1rem;"/>
                        </div>
                        <div class="d-flex align-items-center" style="margin-right: 10px;">
                            <img src="~@/assets/pack_go/user-icon.svg" width="14px" height="16px" style="margin-right: 5px"/>
                            <p class="delivery-man-detail">John Doe / Company Ltd.</p>
                        </div>
                        <div class="d-flex align-items-center">
                            <img src="~@/assets/pack_go/flag-icon.svg" width="20px" height="20px" style="margin-right: 5px"/>
                            <p class="delivery-man-detail">FR</p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="d-flex">
                        <span class="order-id-label">-</span>
                    </div>
                </div>
            </div>
            <div class="header-actions-div d-flex align-items-center flex-row-reverse mx-auto mx-md-0 pb-3 pb-md-0">
                <BButton v-if="is_empty" :disabled="true" @click="openModal()" class="disabled-create-label-btn">
                    Create Label
                </BButton>
                <BButton v-else @click="openModal()" class="create-label-btn">
                    Create Label
                </BButton>
                <BButton v-if="!is_empty" @click="nextItem()" class="small-btn">
                    <img src="~@/assets/pack_go/arrow-right-icon.svg"/>
                </BButton>
                <BButton v-if="!is_empty" @click="prevItem()" class="small-btn">
                    <img src="~@/assets/pack_go/arrow-left-icon.svg"/>
                </BButton>
                <BButton class="small-btn">
                    <img src="~@/assets/pack_go/pencil-icon.svg"/>
                </BButton>
            </div>
        </div>
        <b-collapse id="collapse-4" v-model="openAccordion" class="mt-2">
            <div class="d-flex justify-content-center">
                <OrderDetailsCard />
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { BButton, BCollapse } from 'bootstrap-vue';
import OrderDetailsCard from './OrderDetailsCard.vue';

export default {
    props: {
        is_empty: {
            type: Boolean,
            default: false
        },
        item_index: {
            type: Number,
            default: 0
        }
    },
    components: {
        BButton,
        BCollapse,
        OrderDetailsCard
    },
    data() {
        return {
            openAccordion: false,
            deg: 0,
            item_count: [3, 2, 1]
        }
    },
    methods: {
        openModal() {
            this.$emit('open-modal')
        },
        rotation() {
            if(this.openAccordion) {
                this.deg = 0;
                this.openAccordion = false
            } else {
                this.deg = 90;
                this.openAccordion = true
            }
        },
        nextItem() {
            this.$emit('next-item')
        },
        prevItem() {
            this.$emit('prev-item')
        }
    }
}
</script>

<style scoped>
    .list-header {
        background-color: #ffffff;
        border: 1px solid #C3C5C7;
        border-radius: 6px;
        width: 100%;
        margin-right: 0px;
        padding: 0px 15px;
    }

    .header-actions-div {
        margin-top: auto;
        margin-bottom: auto;
    }

    .disabled-create-label-btn {
        background: #E7E7E7;
        border: 1px solid #787878;
        height: 2.5rem;
        width: 126px;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 0.9rem;
        line-height: 20px;
        text-align: center;
        margin-left: 10px;
        color: #787878;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .create-label-btn {
        background-color: #112857;
        height: 2.5rem;
        width: 126px;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 0.9rem;
        line-height: 20px;
        text-align: center;
        margin-left: 10px;
    }

    .small-btn {
        width: 2.5rem;
        height: 2.5rem;
        border: 1px solid #112857;
        border-radius: 6px;
        background-color: #ffffff;
        margin-left: 10px;
    }

    .small-btn img {
        margin-left: auto;
        margin-right: auto;
        width: 1rem;
    }

    .small-btn:hover {
        background-color: #D2EAFF;
    }
    
    .caret-icon {
        background-color: #ffffff !important;
        border: none;
        margin-top: auto;
        margin-bottom: auto;
        border:1px solid #ffffff !important;
        outline: none;
    }

    .caret-icon:hover {
        background-color: #ffffff !important;
        border:1px solid #ffffff !important;
        outline: none !important;
    }

    .caret-icon:focus {
        box-shadow: none !important;
    }

    .transition {
        transition: transform 0.5s ease-in-out;
    }

    .order-id-label {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 1.5rem;
        color: #212121;
        margin-top: auto;
    }

    .header-item-count {
        margin-left: 8px;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 1rem;
        color: #212121;
        line-height: 33px;
        margin-top: auto;
    }

    .list-label {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 1rem;
        margin-top: auto;
        margin-bottom: auto;
        color: #212121;
    }
    
    .divider {
        border-left: 1px solid #C3C5C7;
        padding-left: 10px;
        padding-right: 10px;
    }

    .delivery-man-detail {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        margin-top: auto;
        margin-bottom: auto;
        color: #212121
    }
</style>